import Button, { Props as ButtonProps } from '@oberoninternal/travelbase-ds/components/action/Button';
import { forwardRef, ForwardRefRenderFunction, useCallback, useState } from 'react';

const AsyncButton: ForwardRefRenderFunction<HTMLButtonElement, ButtonProps> = ({ onClick, ...props }, ref) => {
    const [loading, setLoading] = useState(false);
    const asyncOnClick = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        async (e: any) => {
            setLoading(true);
            // eslint-disable-next-line @typescript-eslint/await-thenable
            await onClick?.(e);
            setLoading(false);
        },
        [onClick]
    );

    return <Button {...props} ref={ref} submitting={loading} onClick={asyncOnClick} />;
};

export default forwardRef(AsyncButton);
